import prefData from "@/data/prefectures.json";
import type { PrefectureInfo } from "./types";

const data = prefData as unknown as {
  by_dept: Record<string, PrefectureInfo>;
  fallback: PrefectureInfo;
};

const PARIS_ARRONDISSEMENTS = new Set(
  Array.from({ length: 20 }, (_, i) => `750${(i + 1).toString().padStart(2, "0")}`),
);

export function getPrefecture(codePostal: string): PrefectureInfo | null {
  if (!codePostal || !/^\d{5}$/.test(codePostal)) return null;

  // Paris arrondissements: 75001..75020 → all map to dept "75"
  if (PARIS_ARRONDISSEMENTS.has(codePostal)) {
    return data.by_dept["75"] ?? data.fallback;
  }

  const dept = codePostal.slice(0, 2);
  return data.by_dept[dept] ?? data.fallback;
}
